import {FC, useEffect, useState} from 'react';
import {Input as ChakraInput} from '@chakra-ui/react';

interface IProps {
  value: string;
  max: number;
  onChange: (value: string) => void;
}

export const TimeField: FC<IProps> = ({value, max, onChange}) => {
  const [text, setText] = useState(value);
  const [isFocused, setIsFocused] = useState(false);

  // Mirror external changes only while the user isn't typing, so manual edits aren't reformatted mid-entry.
  useEffect(() => {
    if (!isFocused) setText(value);
  }, [value, isFocused]);

  const handleBlur = () => {
    setIsFocused(false);
    if (text.trim() === '') {
      setText(value);
      return;
    }
    onChange(String(Math.min(max, Math.max(0, Number(text)))));
  };

  return (
    <ChakraInput
      type={'text'}
      inputMode={'numeric'}
      w={'52px'}
      h={'36px'}
      px={'8px'}
      textAlign={'center'}
      fontSize={'15px'}
      color={'{colors.textPrimary}'}
      background={'{colors.white}'}
      border={'thin solid'}
      borderColor={'{colors.bgMain}'}
      borderRadius={'4px'}
      _focus={{borderColor: '{colors.textPrimary}'}}
      _hover={{borderColor: '{colors.textPrimarySuperLight}'}}
      css={{'--focus-color': 'transparent'}}
      value={text}
      onFocus={() => setIsFocused(true)}
      onChange={(e) => setText(e.target.value.replace(/\D/g, '').slice(0, 2))}
      onBlur={handleBlur}
      onKeyDown={(e) => {
        if (e.key === 'Enter') e.currentTarget.blur();
      }}
    />
  );
};
